
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 5H4v2h3V5zM7 9H4v2h3V9zM7 13H4v2h3v-2zM7 17H4v2h3v-2zM20 5H9v2h11V5zM20 9H9v2h11V9zM20 13H9v2h11v-2zM20 17H9v2h11v-2z","fill":"currentColor"}})])
          )
        }
      }
    